import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'

const options = { 
  path: '',
  autoConnect: false };

Vue.use(new VueSocketIO({
    debug: process.env.NODE_ENV !== 'production',
    connection: SocketIO(process.env.VUE_APP_URL, options), //options object is Optional
  })
)
